import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

const AUTO_ADVANCE_KEY = 'eva.autoAdvance';

function readAutoAdvance(): boolean {
  try {
    return localStorage.getItem(AUTO_ADVANCE_KEY) === '1';
  } catch {
    return false;
  }
}

export const usePreferencesStore = defineStore('preferences', () => {
  const autoAdvance = ref(readAutoAdvance());

  watch(autoAdvance, (value) => {
    try {
      localStorage.setItem(AUTO_ADVANCE_KEY, value ? '1' : '0');
    } catch {
      return;
    }
  });

  return { autoAdvance };
});
